import React, { useMemo } from "react";

import styled from "styled-components";

function ManuscriptShortcutModal({ ActionButton, Dialog, DialogBody, DialogHeader, onClose, Overlay }) {
    const isMac = useMemo(() => /Mac|iPhone|iPad|iPod/i.test(window.navigator.platform || ""), []);
    const shortcutRows = useMemo(
        () => [
            { category: "에디터", key: isMac ? "Cmd + S" : "Ctrl + S", desc: "문서 저장" },
            { category: "에디터", key: isMac ? "Cmd + F" : "Ctrl + F", desc: "검색 패널 열기" },
            { category: "에디터", key: isMac ? "Cmd + Z" : "Ctrl + Z", desc: "실행 취소" },
            {
                category: "에디터",
                key: isMac ? "Cmd + Shift + Z" : "Ctrl + Shift + Z",
                desc: "다시 실행",
            },
            { category: "PDF", key: isMac ? "Cmd + Wheel" : "Ctrl + Wheel", desc: "PDF 확대/축소" },
        ],
        [isMac],
    );

    return (
        <Overlay onClick={onClose}>
            <Dialog
                onClick={(event) => {
                    event.stopPropagation();
                }}
            >
                <DialogHeader>
                    <div>키보드 단축키</div>
                    <ActionButton type="button" onClick={onClose}>
                        닫기
                    </ActionButton>
                </DialogHeader>
                <DialogBody>
                    <ShortcutTable>
                        <ShortcutCell $header>영역</ShortcutCell>
                        <ShortcutCell $header>키</ShortcutCell>
                        <ShortcutCell $header $last>
                            기능
                        </ShortcutCell>
                        {shortcutRows.map((row, index) => (
                            <React.Fragment key={`${row.category}-${row.key}-${index}`}>
                                <ShortcutCell>{row.category}</ShortcutCell>
                                <ShortcutCell>{row.key}</ShortcutCell>
                                <ShortcutCell $last>{row.desc}</ShortcutCell>
                            </React.Fragment>
                        ))}
                    </ShortcutTable>
                </DialogBody>
            </Dialog>
        </Overlay>
    );
}

const ShortcutTable = styled.div`
    display: grid;
    grid-template-columns: minmax(120px, 160px) minmax(110px, 150px) minmax(0, 1fr);
    border: 1px solid #dbe5ef;
    border-radius: 8px;
    overflow: hidden;
`;

const ShortcutCell = styled.div`
    padding: 8px 10px;
    border-bottom: 1px solid #e6edf5;
    border-right: ${(props) => (props.$last ? "0" : "1px solid #e6edf5")};
    background: ${(props) => (props.$header ? "#f4f8fc" : "#ffffff")};
    font-size: 12px;
    font-weight: ${(props) => (props.$header ? 700 : 500)};
    color: #2f455c;
`;

export default ManuscriptShortcutModal;
